export default {
	title: "Tickets",
	goToAttendance: "Distribuir Fichas",
	addObservation: "Agregar Observación",
	observation: "Observación",
	attendanceCard: "Ficha de Atención",
	cancel: "Cancelar",
	cancelledAt: "Cancelada en",
	confirmStatusChange: "Confirmar Cambio de Estado",
	consultant: "Consultante",
	createdAt: "Creada en",
	deleteConfirmation: "¿Desea realmente eliminar la ficha {code}?",
	finishAttendance: "Finalizar Atención",
	finishedAt: "Finalizada en",
	guide: "Guía",
	medium: "Médium",
	notAssigned: "No asignado",
	notes: "Observaciones",
	pendingTickets: "Fichas Pendientes",
	print: "Imprimir",
	startAttendance: "Iniciar Atención",
	startedAt: "Iniciada en",
	statusLabel: "Estado",
	ticketDetails: "Detalles de la Ficha",
	noTicketsFound: "Ninguna ficha encontrada",
	noTicketsDescription: "Esta persona aún no tiene fichas de atención",
	status: {
		CANCELLED: "Cancelado",
		COMPLETED: "Completado",
		IN_PROGRESS: "En Atención",
		PENDING: "En Espera",
	},
	statusChangeConfirmation: "¿Desea cambiar el estado de la ficha {code} a {status}?",
	table: {
		headers: {
			code: "Código",
			consultant: "Consultante",
			medium: "Médium",
			attendanceCard: "Ficha de Atención",
			guide: "Guía",
			status: "Estado",
		},
	},
	messages: {
		loadError: "Error al cargar tickets",
		observationAdded: "Observación actualizada con éxito",
		errorFetching: "Error al cargar fichas",
		errorUpdating: "Error al actualizar ficha",
		statusUpdated: "Estado de la ficha actualizado",
		ticketCancelled: "Ficha cancelada",
		ticketCreated: "Ficha {code} creada con éxito",
		ticketDeleted: "Ficha eliminada con éxito",
		ticketUpdated: "Ficha actualizada con éxito",
	},
	timeline: {
		daysSinceLastVisit: "días sin atención",
		startedIn: "Inició en",
		today: "Hoy",
	},
	personAttendances: {
		title: "Atenciones",
		received: "Recibidas",
		given: "Realizadas",
		timeline: "Línea de tiempo",
		list: "Lista",
	},
	mediumAttendances: {
		title: "Atenciones Realizadas",
		exportPdf: "Exportar PDF",
		pdfError: "Error al generar el PDF de atenciones",
		empty: "No se encontraron atenciones en el período",
		filters: {
			thisYear: "Este año",
		},
		kpis: {
			attendances: "Atenciones",
			rituals: "Rituales",
			totalTime: "Tiempo total",
			avgTime: "Tiempo promedio",
		},
		table: {
			date: "Fecha",
			ritual: "Ritual",
			duration: "Duración",
		},
	},
};
